import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: [
    'M10 1c-4.97 0-9 4.03-9 9s4.03 9 9 9 9-4.03 9-9-4.03-9-9-9zm0 17c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z',
    'M10 6H9v5h6v-1h-5z',
  ],
  height: 20,
  width: 20,
});
